module.exports = __webpack_public_path__ + "static/media/inlet-psi-button.9e2d77ce.png";